
const digest = 'c3097a79da5ec0cab3713f8adf362b5985970382bfee29a243b930ba25e0f9e8';
const classes = {"background":"_background_d78g2_1","list":"_list_d78g2_13","grid":"_grid_d78g2_24"};
const css = `._background_d78g2_1 {
  height: 100%;
  overflow: auto;
}
._background_d78g2_1 .infinite-scroll-component__outerdiv {
  height: 100%;
  flex: 1;
}
._background_d78g2_1 .infinite-scroll-component {
  overflow: visible !important;
}

._list_d78g2_13 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100%;
  font-family: "Rubik", sans-serif;
  background: #fbfbfd;
  padding-top: 12px;
  gap: 12px;
}

._grid_d78g2_24 {
  margin: 0 auto;
  display: grid;
  gap: 24px;
  background: #fbfbfd;
  padding-top: 12px;
  overflow: visible !important;
}

@media (min-width: 600px) {
  ._grid_d78g2_24 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 900px) {
  ._grid_d78g2_24 {
    grid-template-columns: repeat(6, 1fr);
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  